export default __webpack_public_path__ + "static/media/horse_clear.0468ceec.png";